var _symbol, _use, _view;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "additive-small",
    viewBox: "0 0 16 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.003.978h-5.101v3.826h-.351l-4.267 4.8c-.312.35-.484.802-.484 1.27v18.8c0 .351.286.637.638.637h14.029a.638.638 0 00.638-.638V10.875c0-.469-.172-.92-.484-1.271l-4.267-4.8h-.35V.978z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#additive-small"
  })), _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "additive-small"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditiveIcon);
export default __webpack_public_path__ + "static/media/additiveIcon.5dceb15e8fe358c989738e133809735f.svg";
export { ForwardRef as ReactComponent };